<template>
  <div class="flex items-center justify-center gap-2">
    <AutosaveIcon
      v-if="!longText"
      v-tooltip="t('legal_text.textEditor.status.autoSave')"
      class="h-4 w-4"
      :alt="t('legal_text.textEditor.status.autoSave')"
    />
    <span
      class="aspect-square h-3 w-3 rounded-full"
      :class="online ? 'bg-green-500' : 'bg-red-500'"
      aria-hidden="true"
    ></span>
    <span v-if="longText" class="text-xs">
      {{ t("legal_text.textEditor.status.autoSave") }}
      {{
        online
          ? t("legal_text.textEditor.status.active")
          : t("legal_text.textEditor.status.inactive")
      }}
    </span>
  </div>
</template>

<script setup lang="ts">
import AutosaveIcon from "~/assets/schema/autosave.svg";

const { t } = useI18n();

const online = useOnline();

defineProps<{
  longText: boolean;
}>();
</script>
